/**
 * TEMPORARY — CRE DICOM structured report download host.
 * This endpoint is on dev ReportingMicroservice.
 * Remove this file and its use in `downloadDicomStructuredReportHtml` when prod is aligned.
 */
export const DEV_DICOM_DOWNLOAD_REPORTING_BASE =
  "https://devvetsapimanagement.azure-api.net/ReportingMicroservice";
